import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";

// Countdown calculator
const getCountdown = (expiry) => {
  if (!expiry) return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: false };
  const end = new Date(expiry).getTime();
  const now = new Date().getTime();
  const distance = end - now;
  if (distance <= 0)
    return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };

  return {
    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((distance % (1000 * 60)) / 1000),
    expired: false,
  };
};

// Arrows
const SampleNextArrow = memo(({ className, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
  >
    <i className="ph ph-caret-right" />
  </button>
));

const SamplePrevArrow = memo(({ className, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
  >
    <i className="ph ph-caret-left" />
  </button>
));

const FlashSalesOne = () => {
  const [offers, setOffers] = useState([]);
  const [timeLeft, setTimeLeft] = useState([]);

  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/offers/flashSale`);
        if (res.data && Array.isArray(res.data)) {
          const activeOffers = res.data.filter((b) => b.status);
          setOffers(activeOffers.slice(0, 4));
        }
      } catch (err) {
        console.error("Error fetching flashSale offers:", err);
      }
    };
    fetchOffer();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (offers.length > 0) {
        const updated = offers.map((offer) => getCountdown(offer.expiryDate));
        setTimeLeft(updated);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [offers]);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1, arrows: false, dots: false },
      },
    ],
  };

  return (
    <>
        {/* Responsive CSS */}
        <style>{`
            @media (max-width: 1024px) {
            .section-heading {
                text-align: center;
                margin-bottom: 0px;
            }

            .flash-sales-item {
                flex-direction: column !important;
                align-items: center !important;
                justify-content: flex-start !important;
                height: auto !important;
                min-height: auto !important;
                padding: 6px !important;
            }

            .flash-sales-item__thumb {
                display: block !important;
                width: 100% !important;
                height: 220px !important;
                margin-bottom: 12px !important;
            }

            .flash-sales-item__content {
                width: 100% !important;
                text-align: center !important;
                padding: 0 !important;
            }

            .flash-sales-item__content h6 {
                font-size: 18px !important;
                margin-bottom: 10px !important;
            }

            .countdown {
                margin-bottom: 0px !important;
            }

            .countdown-list {
                justify-content: center !important;
                gap: 6px !important;
                font-size: 13px !important;
            }

            .btn.btn-main {
                font-size: 13px !important;
                padding: 8px 16px !important;
                border-radius: 30px !important;
            }

            }

            @media (max-width: 576px) {
            .flash-sales-item__thumb {
                height: 180px !important;
            }

            .flash-sales-item__content h6 {
                font-size: 16px !important;
            }

            .btn.btn-main {
                font-size: 12px !important;
                padding: 6px 12px !important;
            }
            .slick-dots{
                display: none !important;
            }
            }
       `}</style>
       
        <section className="flash-sales pt-80" id="flashSaleToday">
        <div className="container container-lg">
            <div className="section-heading">
              <div className="flex-between flex-wrap gap-8">
                <h5 className="mb-0">Flash Sales Today</h5>
              </div>
            </div>

            <div className="flash-sales__slider arrow-style-two">
            <Slider {...settings}>
                {offers.map((offer, index) => {
                const timer = timeLeft[index] || {};
                return (
                    <div key={index}>
                    <div
                        className="flash-sales-item rounded-16 overflow-hidden z-1 position-relative flex-align flex-0 justify-content-between gap-8"
                        style={{
                        height: "350px",
                        minHeight: "350px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        }}
                    >
                        {/* Background */}
                        <img
                        src={`assets/images/bg/flash-sale-bg${index % 2 === 0 ? 1 : 2}.png`}
                        alt=""
                        className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 object-fit-cover z-n1 flash-sales-item__bg"
                        />

                        {/* Product Image */}
                        <div
                        className="flash-sales-item__thumb d-sm-block d-none"
                        style={{
                            width: "400px",
                            height: "250px",
                            overflow: "hidden",
                            borderRadius: "12px",
                            flexShrink: 0,
                        }}
                        >
                        <img
                            src={offer.image}
                            alt={offer.title}
                            style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            }}
                        />
                        </div>

                        {/* Content */}
                        <div className="flash-sales-item__content ms-sm-auto">
                        <h6
                            className="text-32 mb-20"
                            style={{ lineHeight: "1.3", fontSize: "26px" }}
                        >
                            {offer.title}
                        </h6>

                        <div className="countdown" id={`countdown-${index}`}>
                            {timer.expired ? (
                            <span className="text-red-500 fw-semibold text-md">
                                Expired
                            </span>
                            ) : (
                            <ul className="countdown-list flex-align flex-wrap gap-5">
                                <li className="text-heading text-sm fw-medium">
                                {timer.days ?? 0} Days
                                </li>
                                <li className="text-heading text-sm fw-medium">
                                {timer.hours ?? 0} Hours
                                </li>
                                <li className="text-heading text-sm fw-medium">
                                {timer.minutes ?? 0} Min
                                </li>
                                <li className="text-heading text-sm fw-medium">
                                {timer.seconds ?? 0} Sec
                                </li>
                            </ul>
                            )}
                        </div>

                        <Link
                            to={offer.link || "/shop"}
                            className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8 mt-12"
                        >
                            Shop Now
                            <span className="icon text-xl d-flex">
                            <i className="ph ph-arrow-right" />
                            </span>
                        </Link>
                        </div>
                    </div>
                    </div>
                );
                })}
            </Slider>
            </div>
        </div>

        </section>
    </>
  );
};

export default FlashSalesOne;
